import React, { useEffect, useState, useRef } from 'react';
import './Dashboard.css';

import ContactSection from './ContactSection/ContactSection';
import FaqSection from './FaqSection/FaqSection';
import HeroSection from './HeroSection/HeroSection';

import { useAuth } from '../../context/AuthContext';

const Dashboard = () => {
  const { user, refreshMembership } = useAuth();

  const [showFaq, setShowFaq] = useState(false);
  const faqRef = useRef(null);

  useEffect(() => {
    if (!user?.email) return;

    let cancelled = false;

    (async () => {
      try {
        await refreshMembership(user.email);
        if (cancelled) return;
      } catch (err) {
        console.error('Error ensuring membership on Dashboard mount:', err);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [user, refreshMembership]);

  // 👇 SOLO activa FAQ
  const handleOpenFaq = () => {
    setShowFaq(true);
  };

  // 👇 scroll automático cuando aparece
  useEffect(() => {
    if (showFaq && faqRef.current) {
      faqRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  }, [showFaq]);

  return (
    <div className="dashboard">
      {/* 👇 PASAMOS LA FUNCIÓN */}
      <HeroSection onOpenFaq={handleOpenFaq} />

      {/* 👇 FAQ oculto hasta click */}
      {showFaq && (
        <section ref={faqRef} className="faq-section-wrapper">
          <FaqSection />
        </section>
      )}

      <ContactSection />
    </div>
  );
};

export default Dashboard;

